import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../assets/styles/style';
import TaskUploadHeading from '../../components/uploadTask/taskUploadHeading';
import BulkTaskDelete from './BulkTaskDelete';
import JsonToExcel from '../../components/uploadTask/JsonToExcel';
import BulkTaskDeleteHeading from '../uploadTask/BulkTaskDeleteHeading'

const BulkTaskDeleteMain = () => {
  const classes = useStyles(); 
  const isJson = window.location.href.includes('json');

  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <BulkTaskDeleteHeading/>
      </Box>
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
          {isJson ? <JsonToExcel/> : <BulkTaskDelete/>}
        </Paper>
      </Box>
    </div>
  );
};

export default BulkTaskDeleteMain;